export default function deletePlanSuccess(state, payload) {
  const { toDelete } = payload;

  return {
    ...state,
    isFetching: false,
    activePlans: state.activePlans.filter(({ branch: { id } }) => id !== toDelete),
    completePlans: state.completePlans.filter(({ branch: { id } }) => id !== toDelete),
  };
}